export default __webpack_public_path__ + "static/media/countries.2d2f3b34.svg";